import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdH2HeadLine = (props) => {
  return <LSBdH2HeadLineWrapper {...props} />;
};

export default LSBdH2HeadLine;

const LSBdH2HeadLineWrapper = styled(LineSeedKrBd)`
  font-size: 18px;
  font-weight: 700;
  line-height: 25.2px;
  letter-spacing: -0.6px;

  color: #222222;
`;
